import { render, staticRenderFns } from "./LayoutAuth.vue?vue&type=template&id=580376d9&scoped=true&"
import script from "./LayoutAuth.vue?vue&type=script&lang=js&"
export * from "./LayoutAuth.vue?vue&type=script&lang=js&"
import style0 from "./LayoutAuth.vue?vue&type=style&index=0&id=580376d9&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580376d9",
  null
  
)

export default component.exports